import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
                        <div className="footer-brand">
                            {/* Logo Image */}
                            <img
                                src="/assets/images/logo.png"
                                alt="LAMSAT Technical Services"
                                className="footer-logo mb-3"
                                style={{
                                    height: '60px',
                                    width: 'auto',
                                    objectFit: 'contain'
                                }}
                            />
                            <h4 className="mb-3 text-white">LAMSAT</h4>
                            <p className="mb-4" style={{ color: '#ccc' }}>
                                Your ultimate one-stop Engineering Service Provider in Dubai, UAE.
                                Specializing in large-scale projects with excellence and precision.
                            </p>
                            <div className="social-icons">
                                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                    <i className="fab fa-facebook-f"></i>
                                </a>
                                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                                    <i className="fab fa-twitter"></i>
                                </a>
                                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                                    <i className="fab fa-linkedin-in"></i>
                                </a>
                                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                    <i className="fab fa-instagram"></i>
                                </a>
                                <a href="https://wa.me/971563670933" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                                    <i className="fab fa-whatsapp"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-2 col-md-6 mb-4 mb-lg-0">
                        <h5 className="mb-4 text-white">Quick Links</h5>
                        <ul className="list-unstyled footer-links">
                            <li className="mb-2">
                                <Link to="/" className="text-decoration-none">
                                    <i className="fas fa-chevron-right me-2 text-primary-red" style={{ fontSize: '0.8rem' }}></i>
                                    Home
                                </Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/about" className="text-decoration-none">
                                    <i className="fas fa-chevron-right me-2 text-primary-red" style={{ fontSize: '0.8rem' }}></i>
                                    About Us
                                </Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/services" className="text-decoration-none">
                                    <i className="fas fa-chevron-right me-2 text-primary-red" style={{ fontSize: '0.8rem' }}></i>
                                    Services
                                </Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/projects" className="text-decoration-none">
                                    <i className="fas fa-chevron-right me-2 text-primary-red" style={{ fontSize: '0.8rem' }}></i>
                                    Projects
                                </Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/blog" className="text-decoration-none">
                                    <i className="fas fa-chevron-right me-2 text-primary-red" style={{ fontSize: '0.8rem' }}></i>
                                    Blog
                                </Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/contact" className="text-decoration-none">
                                    <i className="fas fa-chevron-right me-2 text-primary-red" style={{ fontSize: '0.8rem' }}></i>
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
                        <h5 className="mb-4 text-white">Our Services</h5>
                        <ul className="list-unstyled footer-links">
                            <li className="mb-2">
                                <i className="fas fa-check-circle me-2 text-primary-red"></i>
                                HVAC Systems
                            </li>
                            <li className="mb-2">
                                <i className="fas fa-check-circle me-2 text-primary-red"></i>
                                Electrical Works
                            </li>
                            <li className="mb-2">
                                <i className="fas fa-check-circle me-2 text-primary-red"></i>
                                Plumbing Services
                            </li>
                            <li className="mb-2">
                                <i className="fas fa-check-circle me-2 text-primary-red"></i>
                                Civil Construction
                            </li>
                            <li className="mb-2">
                                <i className="fas fa-check-circle me-2 text-primary-red"></i>
                                Waterproofing
                            </li>
                            <li className="mb-2">
                                <i className="fas fa-check-circle me-2 text-primary-red"></i>
                                Metal & Aluminum Work
                            </li>
                        </ul>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <h5 className="mb-4 text-white">Contact Info</h5>
                        <div className="contact-info">
                            <div className="mb-3 d-flex align-items-start">
                                <i className="fas fa-map-marker-alt me-3 mt-1 text-primary-red"></i>
                                <div>
                                    <p className="mb-0 text-white" style={{ fontSize: '0.9rem' }}>Office Address:</p>
                                    <p className="mb-0" style={{ color: '#ccc', fontSize: '0.85rem' }}>
                                        Office No.33, Second Floor,<br />
                                        Building Smark 2, Ras Al Khor,<br />
                                        Dubai, UAE
                                    </p>
                                </div>
                            </div>
                            <div className="mb-3 d-flex align-items-center">
                                <i className="fas fa-phone me-3 text-primary-red"></i>
                                <div>
                                    <p className="mb-0 text-white" style={{ fontSize: '0.9rem' }}>Phone Numbers:</p>
                                    <p className="mb-0" style={{ color: '#ccc', fontSize: '0.85rem' }}>
                                        +971 4 326 2259 (Office)<br />
                                        +971 56 858 3383 (Mobile)
                                    </p>
                                </div>
                            </div>
                            <div className="mb-3 d-flex align-items-center">
                                <i className="fas fa-envelope me-3 text-primary-red"></i>
                                <div>
                                    <p className="mb-0 text-white" style={{ fontSize: '0.9rem' }}>Email:</p>
                                    <p className="mb-0" style={{ color: '#ccc', fontSize: '0.85rem' }}>
                                        sales@lamsatalbedaya.com
                                    </p>
                                </div>
                            </div>
                            <div className="d-flex align-items-center">
                                <i className="fab fa-whatsapp me-3 text-primary-red"></i>
                                <div>
                                    <p className="mb-0 text-white" style={{ fontSize: '0.9rem' }}>WhatsApp:</p>
                                    <a
                                        href="https://wa.me/971563670933"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: '#25D366', fontSize: '0.85rem' }}
                                        className="text-decoration-none"
                                    >
                                        +971 56 367 0933
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-5 pt-4 border-top border-secondary">
                    <div className="col-md-6">
                        <p className="mb-0" style={{ color: '#999', fontSize: '0.85rem' }}>
                            &copy; {currentYear} LAMSAT Omer & Mohammed Technical Services L.L.C.
                            All rights reserved.
                        </p>
                    </div>
                    <div className="col-md-6 text-md-end">
                        <p className="mb-0" style={{ color: '#999', fontSize: '0.85rem' }}>
                            TRN: 104929219400003 | License No: 880897 | Reg No: 2552101
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;